import { Badge as InternalBadge } from '@bpinternal/ui-kit-next'
import { ComponentProps } from 'react'
import { Color } from '~/types'
import { cn } from '../utils'

type Props = {
  color?: Color
} & ComponentProps<typeof InternalBadge>

const variantMap = (color: Color, variant: ComponentProps<typeof InternalBadge>['variant']) => {
  return {
    default: `bg-${color}-500`,
    secondary: `bg-${color}-${color === 'neutral' ? '200' : '100'} text-${color}-600`,
    destructive: `bg-${color}-50 text-${color}-500`,
    outline: `bg-${color}-50 text-${color}-500 border-${color}-400`,
  }[variant ?? 'default']
}

const getColorVariant = (color: Color, variant: ComponentProps<typeof InternalBadge>['variant']): string => {
  return variantMap(color, variant)
}

export const Badge = ({ ref, children, className, color, variant, ...props }: Props) => {
  return (
    <InternalBadge
      ref={ref}
      className={cn(color && getColorVariant(color, variant), className)}
      variant={variant}
      {...props}
    >
      {children}
    </InternalBadge>
  )
}

Badge.displayName = 'Badge'
